import { render } from "./aboutPark.vue?vue&type=template&id=47555f2c&scoped=true"
import script from "./aboutPark.vue?vue&type=script&lang=js"
export * from "./aboutPark.vue?vue&type=script&lang=js"

import "./aboutPark.vue?vue&type=style&index=0&id=47555f2c&lang=scss&scoped=true"

import exportComponent from "E:\\Gitlab\\02_各园区PC端\\happyHarbour\\ningbo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47555f2c"]])

export default __exports__